// eslint-disable-next-line no-unused-vars
import { CareerAndSeasonStatsState } from './career-and-season-stats/types';
import { PerformanceChartState } from './performance-chart/types';
// eslint-disable-next-line no-unused-vars
import { StatsLeadersState } from './stats-leaders/types';
import './season-leaders/reducer/types';
import './last-round-highs/reducer/types';

/**
 * @typedef {object} StatsState
 * @property {StatsLeadersState} statsLeaders
 * @property {CareerAndSeasonStatsState} careerAndSeasonStats
 * @property {object} glossary
 * @property {SeasonLeadersState} seasonLeaders
 * @property {LastRoundHighsState} lastRoundHighs
 * @property {PerformanceChartState} performanceChart
 */

/**
 * @typedef {'seasons'|'rounds'} StatsLeadersStatsType
 * @typedef {'round'|'season'} LastRoundHighsStatsType
 */